import React from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

// Global safety net — without this, any uncaught render error anywhere in the
// app (a bad prop, a null field, a third-party script interfering with state)
// white-screens the entire app with no way to recover except a manual reload.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Uncaught app error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center px-6 bg-background">
          <div className="max-w-sm text-center">
            <AlertTriangle className="w-10 h-10 text-destructive mx-auto mb-4" />
            <h1 className="text-lg font-semibold text-foreground mb-2">Something went wrong</h1>
            <p className="text-sm text-muted-foreground mb-6">
              This page hit an unexpected error. Reloading usually fixes it.
            </p>
            <Button onClick={() => window.location.reload()}>Reload page</Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}